import { setEnvironment } from '@minecraft.environment';
import { environment } from './environment';

// This is needed to make environment accessible to minecraft/blocs directly
// Ideally blocs/minecraft should NOT use environment variables directly
setEnvironment(environment);

export { environment };
